import { Component } from '@theme/component';

export class AnnouncementBar extends Component {
  connectedCallback() {
    super.connectedCallback();

    const slidesContainer = this.querySelector('.announcement-bar__slides');

    const duplicate = () => {
      if (slidesContainer && slidesContainer.children.length > 0) {
        const original = slidesContainer.innerHTML;
        slidesContainer.innerHTML = original + original;
      }
    };

    if (slidesContainer && slidesContainer.children.length > 0) {
      duplicate();
    } else {
      const observer = new MutationObserver(() => {
        if (slidesContainer.children.length > 0) {
          observer.disconnect();
          duplicate();
        }
      });
      observer.observe(slidesContainer, { childList: true, subtree: true });
    }

    this.addEventListener('mouseenter', () => {
      slidesContainer.style.animationPlayState = 'paused';
    });

    this.addEventListener('mouseleave', () => {
      slidesContainer.style.animationPlayState = 'running';
    });
  }
}

if (!customElements.get('announcement-bar-component')) {
  customElements.define('announcement-bar-component', AnnouncementBar);
}
